class CheckoutBc {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elems = elem.querySelectorAll(`[href="${window.location.origin}/cart"]`)
    }

    onInit () {
        for (let elem of this._elems) {
            elem.href = `${window.location.pathname}?step=contact_information`
        }
    }
}

export default CheckoutBc



// WEBPACK FOOTER //
// ./src/scripts/components/CheckoutBc.js